import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Heart, Users, BriefcaseBusiness } from 'lucide-react';
import './Home.css';

export const Home = () => {
  const [selectedImage, setSelectedImage] = React.useState(null);

  const services = [
    {
      icon: <Heart size={32} />,
      title: 'Embodied Healing',
      description: 'Coming home to the body as a temple of truth through gentle, transformative practices.',
      image: 'https://customer-assets.emergentagent.com/job_33648ce9-55a6-4073-8c73-14e57d771a90/artifacts/s3sjmdwk_WhatsApp%20Image%202026-04-16%20at%2013.16.18.jpeg',
      imagePosition: 'center 35%'
    },
    {
      icon: <Sparkles size={32} />,
      title: 'Emotional Liberation',
      description: 'Releasing old pain, shame, and self-abandonment to embrace your authentic self.',
      image: 'https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/98mvxy4v_image9.jpeg',
      imagePosition: '25% center'
    },
    {
      icon: <Users size={32} />,
      title: 'Sacred Union',
      description: 'Integration of inner masculine & feminine energies for wholeness and balance.',
      image: 'https://customer-assets.emergentagent.com/job_33648ce9-55a6-4073-8c73-14e57d771a90/artifacts/0os0qs11_IMG-20260421-WA0006.jpg',
      imagePosition: 'center 25%'
    },
    {
      icon: <BriefcaseBusiness size={32} />,
      title: 'Corporate Wellness',
      description: 'Transform workplace culture through relationship and emotional wellness workshops.',
      image: 'https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/u6q0hp14_image11.jpeg'
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-announcement">
            <Sparkles size={14} />
            <span>Where Healing, Embodiment & Soulful Living Meet</span>
          </div>
          <h1 className="heading-hero">
            Tshidi Tsimile Company
          </h1>
          <p className="body-large" style={{ marginBottom: '2rem', maxWidth: '700px', marginLeft: 'auto', marginRight: 'auto' }}>
            Guiding women and men back to the pleasure of being alive — the pleasure of feeling, knowing, and trusting themselves.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary">Contact Us</Link>
            <Link to="/about" className="btn-secondary">Learn More</Link>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview-section">
        <div className="container">
          <div className="about-preview-grid">
            <div className="about-preview-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_aec52aac-54e5-4016-8334-de13af7543de/artifacts/sqyr4h1v_lwp3hqu4_Screenshot_20251127-142154_Instagram.jpg" 
                alt="Tshidi Tsimile"
              />
            </div>
            <div className="about-preview-content">
              <h2 className="heading-1">Pleasure is Not Indulgence — It is Medicine</h2>
              <p className="body-medium" style={{ marginBottom: '1.5rem' }}>
                Inspired by The Ministry of Pleasure, my work anchors the truth that pleasure is alignment and the deepest form of prayer.
              </p>
              <p className="body-medium" style={{ marginBottom: '1.5rem' }}>
                I help individuals and communities reconnect with embodied healing, emotional liberation, and spiritual awakening.
              </p>
              <p className="body-medium" style={{ marginBottom: '2rem' }}>
                My teachings weave psychology, spirituality, ancestral wisdom, and sensual embodiment into practical healing pathways that return people to wholeness, confidence, and inner radiance.
              </p>
              <Link to="/about" className="btn-primary">Discover My Story</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">What I Offer</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto' }}>
              Holistic pathways to healing, embodiment, and soulful living
            </p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.title} className="service-card hover-lift">
                <div 
                  className="service-card-image"
                  onClick={() => setSelectedImage(service.image)}
                  style={{ cursor: 'pointer' }}
                >
                  <img 
                    src={service.image} 
                    alt={service.title}
                    style={{ objectPosition: service.imagePosition || 'center center' }}
                  />
                </div>
                <div className="service-card-content">
                  <div className="service-icon">{service.icon}</div>
                  <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>{service.title}</h3>
                  <p className="body-small">{service.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Image Modal */}
          {selectedImage && (
            <div 
              className="image-modal"
              onClick={() => setSelectedImage(null)}
            >
              <div className="image-modal-content">
                <button 
                  className="image-modal-close"
                  onClick={() => setSelectedImage(null)}
                  aria-label="Close"
                >
                  ×
                </button>
                <img src={selectedImage} alt="Full view" />
              </div>
            </div>
          )}

          <div className="section-cta">
            <Link to="/services" className="btn-primary">Explore All Services</Link>
          </div>
        </div>
      </section>

      {/* Corporate Section */}
      <section className="corporate-preview-section">
        <div className="container">
          <div className="corporate-content">
            <h2 className="heading-1" style={{ marginBottom: '1.5rem' }}>Corporate Wellness Programs</h2>
            <p className="body-large" style={{ marginBottom: '1.5rem' }}>
              When a person's inner world and relationships are harmonized, it naturally reflects in their work.
            </p>
            <p className="body-medium" style={{ marginBottom: '2rem' }}>
              I deliver workshops that help employees navigate their relationships, marriages, and emotional challenges — leading to greater focus, higher productivity, better communication, and stronger results.
            </p>
            <Link to="/corporate" className="btn-primary">Learn About Corporate Programs</Link>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="heading-1" style={{ marginBottom: '2rem', textAlign: 'center' }}>Healing in Action</h2>
          <div className="gallery-grid">
            <img 
              src="https://customer-assets.emergentagent.com/job_aec52aac-54e5-4016-8334-de13af7543de/artifacts/m8jvz1m8_IMG-20260311-WA0005.jpg" 
              alt="Healing session" 
              className="gallery-image" 
              onClick={() => setSelectedImage('https://customer-assets.emergentagent.com/job_aec52aac-54e5-4016-8334-de13af7543de/artifacts/m8jvz1m8_IMG-20260311-WA0005.jpg')}
              style={{ cursor: 'pointer' }}
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_aec52aac-54e5-4016-8334-de13af7543de/artifacts/44lmkm61_IMG-20260311-WA0006.jpg" 
              alt="Workshop" 
              className="gallery-image" 
              onClick={() => setSelectedImage('https://customer-assets.emergentagent.com/job_aec52aac-54e5-4016-8334-de13af7543de/artifacts/44lmkm61_IMG-20260311-WA0006.jpg')}
              style={{ cursor: 'pointer' }}
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_33648ce9-55a6-4073-8c73-14e57d771a90/artifacts/mp5ccmik_WhatsApp%20Image%202026-04-16%20at%2010.23.22.jpeg" 
              alt="Group session" 
              className="gallery-image" 
              onClick={() => setSelectedImage('https://customer-assets.emergentagent.com/job_33648ce9-55a6-4073-8c73-14e57d771a90/artifacts/mp5ccmik_WhatsApp%20Image%202026-04-16%20at%2010.23.22.jpeg')}
              style={{ cursor: 'pointer' }}
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/v9hzdwf7_When%20women%20gather%20there%20is%20a%20special%20medicine%20and%20anointing%20that%20drops%20from%20above.%23kefodilemove.webp%20%282%29.jpg" 
              alt="Embodiment work" 
              className="gallery-image" 
              onClick={() => setSelectedImage('https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/v9hzdwf7_When%20women%20gather%20there%20is%20a%20special%20medicine%20and%20anointing%20that%20drops%20from%20above.%23kefodilemove.webp%20%282%29.jpg')}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1" style={{ marginBottom: '1.5rem' }}>Ready to Begin Your Journey?</h2>
            <p className="body-large" style={{ marginBottom: '2rem' }}>
              You are meant to live a life that feels good — in your body, your relationships, your emotions, and your spirit.
            </p>
            <Link to="/contact" className="btn-primary">Book Your Session Today</Link>
          </div>
        </div>
      </section>
    </div>
  );
};